<h2>Order #{{this.order?.orderId}}</h2>
@if (order) {
  <div class="order-wrapper">
    <section class="summary-and-payments">
      <div class="summary-wrapper">
        <h3 class="summary-title">Summering</h3>
        <app-order-items [order]="order" [renderType]="'order'"></app-order-items>
        <section class="order-summary">
          <ul>
            <li class="total"><span>Total: </span><span>{{order.totalAmount}} kr</span></li>
            @if (order.discount) {
              <li>
                <span>Total utan rabatt: </span>
                <span>{{order.totalAmountWithoutDiscount}} kr</span>
              </li>
            }
            <li><span>Betalat belopp: </span><span>{{order.paidAmount}} kr</span></li>
            @if (order.refundedAmount) {
              <li>
                <span>Återbetalat belopp: </span>
                <span>- {{order.refundedAmount}} kr</span>
              </li>
            }
            <li>
              <span>{{order.amountToPay !== undefined &&
              order.amountToPay < 0 ? 'Kvar att återbetala:' : 'Kvar att betala:' }} </span>
              <span>{{order.amountToPay}} kr</span>
            </li>
          </ul>
        </section>
      </div>
      <!-- Payments -->
      <section class="payments">
        <h3>Betalningar</h3>
        <ul>
          @for (payment of order.payments; track payment) {
            @if (payment.transactionType !== 'REFUND') {
              <li>
                <div class="flex-container">
                  <div class="date-and-type"
                    [title]="payment.externalOrderId ? 'Kustom order-ID: ' + payment.externalOrderId : ''">
                    <span>
                      {{formatDate(payment.transactionDate) || 'Okänt datum'}}
                      {{formatTime(payment.transactionDate) || 'okänd tid'}}
                    </span>
                    <span>{{payment.paymentMethod?.label || 'okänd betalningsmetod'}}</span>
                  </div>
              <span [ngClass]="{'no-receipt': payment.paymentMethod?.paymentMethodId === 'INVOICE'
                && order.payments 
                && order.payments.length > 1}">
                {{payment?.amount}} kr
                @if (payment.paymentMethod?.paymentMethodId !== 'INVOICE') {
<button class="button slim"
                  [ngClass]="{'loading': loadingPaymentEmail}"
                        [title]="payment.paymentMethod?.paymentMethodId === 'KLARNA' ? 'Skicka Klarna-kvittokopia' : 'Skriv ut kvitto'"
                        (click)="payment.paymentMethod?.paymentMethodId === 'KLARNA' ? sendKlarnaReceipt(payment) : printReceipt(payment.paymentId)">
                        @if (payment.paymentMethod?.paymentMethodId !== 'KLARNA') {
                          <mat-icon>receipt</mat-icon>
                        }
                        @if (payment.paymentMethod?.paymentMethodId === 'KLARNA') {
                          <mat-icon>email</mat-icon>
                        }
                        @if (loadingPaymentEmail) {
                          <mat-spinner diameter="25" color="accent"></mat-spinner>
                        }
                      </button>
                    }
                    <!-- Invoice status -->
                    @if (payment.paymentMethod?.paymentMethodId === 'INVOICE') {
                      <span>|</span>
                    }
                    @if (payment.paymentMethod?.paymentMethodId === 'INVOICE') {
                      <div>
                        @if (invoiceStatusForm) {
                          <form [formGroup]="invoiceStatusForm">
                            <mat-checkbox [formControlName]="payment?.paymentId ? payment.paymentId!.toString() : null">
                              <span class="handled-checkbox-label">Fakturerad</span>
                            </mat-checkbox>
                          </form>
                        }
                      </div>
                    }
                  </span>
                </div>
              </li>
            }
          }
        </ul>
        <!-- Invoice information -->
        @if (invoice) {
          <div class="invoice-header-row">
            <mat-accordion class="invoice-accordion">
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <span>Fakturauppgifter</span>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <ul class="invoice-information">
                  <li><span>Organisations-/personnummer: </span><span class="value-to-end">{{
                  invoice.organizationNumber
                }}</span></li>
                <li><span>Referens: </span><span class="value-to-end">{{ invoice.reference || '-' }}</span></li>
                <li><span>Namn: </span><span class="value-to-end">{{ invoice.name }}</span></li>
                <li><span>E-post kontakt: </span><span class="value-to-end">{{ invoice.email }}</span></li>
                <li><span>Telefonnummer: </span><span class="value-to-end">{{ invoice.phone }}</span></li>
                <li>
                  <span>E-faktura: </span>
                  <span class="value-to-end">{{ invoice.invoiceEmail || '-' }}</span>
                </li>
                <li><span>Adress: </span><span class="value-to-end">{{ invoice.address }}</span></li>
                <li><span>Postnummer: </span><span class="value-to-end">{{ invoice.zip }}</span></li>
                <li><span>Stad: </span><span class="value-to-end">{{ invoice.city }}</span></li>
                <li><span>Land: </span><span class="value-to-end">{{ invoice.country }}</span></li>
              </ul>
            </mat-expansion-panel>
          </mat-accordion>
          <!-- Edit button -->
          <div class="edit-button-wrapper">
            <button class="icon-button icon-button-edit" title="Redigera" (click)="openInvoicePopup()">
              <mat-icon>edit</mat-icon>
            </button>
          </div>
        </div>
      }
      @if (!order.payments || order.payments.length <= 0) {
        <div class="empty-content">
          <p>Inga betalningar</p>
        </div>
      }
      @if (emailPaymentMsg) {
        <p [ngClass]="{'email-msg': true, 'success': emailSent, 'failed': !emailSent}">
          {{emailPaymentMsg}}
        </p>
      }
    </section>
    <!-- Refunds -->
    @if (order.refundedAmount) {
      <section class="refunds">
        <h3>Återbetalningar</h3>
        <ul>
          @for (payment of order.payments; track payment) {
            @if (payment.transactionType === 'REFUND') {
              <li>
                <div class="flex-container">
                  <div class="date-and-type"
                    [title]="payment.externalOrderId ? 'Kustom order-ID: ' + payment.externalOrderId : ''">
                    <span>
                      {{formatDate(payment.transactionDate) || 'Okänt datum'}}
                      {{formatTime(payment.transactionDate) || 'okänd tid'}}
                    </span>
                    <span>
                      {{payment.paymentMethod?.label || 'okänd betalningsmetod'}}
                    </span>
                  </div>
                  <span>
                    -{{payment?.amount}} kr
                    @if (payment.paymentMethod?.paymentMethodId !== 'INVOICE') {
                      <button class="button slim" [ngClass]="{'loading': loadingRefundEmail}"
                        [title]="payment.paymentMethod?.paymentMethodId === 'KLARNA' ? 'Skicka Klarna-kvittokopia' : 'Skriv ut kvitto'"
                        (click)="payment.paymentMethod?.paymentMethodId === 'KLARNA' ? sendKlarnaReceipt(payment) : printReceipt(payment.paymentId)">
                        @if (payment.paymentMethod?.paymentMethodId !== 'KLARNA') {
                          <mat-icon>receipt</mat-icon>
                        }
                        @if (payment.paymentMethod?.paymentMethodId === 'KLARNA') {
                          <mat-icon>email</mat-icon>
                        }
                        @if (loadingRefundEmail) {
                          <mat-spinner diameter="25" color="accent"></mat-spinner>
                        }
                      </button>
                    }
                  </span>
                </div>
                <p class="refund-comment">Kommentar: {{payment.comment || 'Ingen kommentar angiven'}}</p>
              </li>
            }
          }
        </ul>
        @if (emailRefundMsg) {
          <p [ngClass]="{'email-msg': true, 'success': emailSent, 'failed': !emailSent}">
            {{emailRefundMsg}}
          </p>
        }
      </section>
    }
  </section>
  <!-- Order info section -->
  <section class="info-section">
    <h3>Orderinformation</h3>
    <ul>
      <li>
        <span>Ordernummer: </span>
        <span class="value-to-end">{{ order.orderId || '-' }}</span>
      </li>
      <li>
        <span>Skapad: </span>
        <span class="value-to-end">{{ formatDate(order.createdDate) || '-' }}
          {{formatTime(order.createdDate) || '--:--'}}
        </span>
      </li>
      <li>
        <span>Skapad av: </span>
        <span class="value-to-end">{{order.createdBy?.name || order.createdBy?.username || 'okänt'}}</span>
      </li>
      <li>
        <span>Uppdaterad: </span>
        <span class="value-to-end">{{ formatDate(order.updatedDate) || '-' }}
          {{formatTime(order.updatedDate) || '--:--'}}
        </span>
      </li>
      <li>
        <span>Uppdaterad av: </span>
        <span class="value-to-end">{{ order.updatedBy?.name || order.updatedBy?.username || 'okänt' }}</span>
      </li>
      <li>
        <span>Status: </span>
        <span class="value-to-end">
          {{!order.payments?.length && order.orderStatus && order.orderStatus !== 'COMPLETED' ?
          'ORDER EJ BEHANDLAD. VÄLJ BETALNINGSMETOD.': 'Skapad'}}
        </span>
      </li>
      @if (!invoice) {
        <li>
          <span> Betalningsstatus: </span>
          <span class="value-to-end">{{ order.paymentStatus?.label || 'okänt' }}</span>
        </li>
      }
    </ul>
    <section class="action-buttons">
      <!-- Handle payment -->
      <button class="button"
        [ngClass]="{'unfinished-payments': hasUnfinishedPayments, 'warning': hasUnfinishedPayments}"
        (click)="goToCheckout()" [disabled]="cancelledBookings">
        {{hasUnfinishedPayments ? 'Påbörjade betalningar ' : 'Hantera betalning'}}
        @if (hasUnfinishedPayments) {
          <mat-icon>warning</mat-icon>
        }
      </button>
      <!-- Order confirmation -->
      <button class="button" [ngClass]="{'loading': loadingConfirmationEmail}" [disabled]="cancelledBookings"
        (click)="sendConfirmationEmail()">Skicka orderbekräftelse
        @if (loadingConfirmationEmail) {
          <mat-spinner diameter="25" color="accent"></mat-spinner>
        }
      </button>
      @if (emailConfirmationMsg) {
        <p [ngClass]="{'email-msg': true, 'success': emailConfirmationSent, 'failed': !emailConfirmationSent}"
          >
          {{emailConfirmationMsg}}
        </p>
      }
    </section>
  </section>
</div>
}

<!-- Receipt -->
<iframe #iframe id="iframe" name="iframe">
</iframe>

<!-- Invoice popup -->
<ng-template #invoiceDialog>
  <h2 mat-dialog-title>Ändra fakturauppgifter</h2>

  <mat-dialog-content>
    <app-invoice-form-fields #fields [value]="invoice ?? undefined" (saved)="onInvoiceSaved($event)"
      (valid)="childFormValid = $event">
    </app-invoice-form-fields>
  </mat-dialog-content>

  <mat-dialog-actions align="center">
    <button mat-button class="round-btn" (click)="closeInvoiceDialog()">Avbryt</button>
    <button mat-flat-button class="round-btn" color="primary" (click)="fields.save()" [disabled]="!childFormValid">
      Spara
    </button>
  </mat-dialog-actions>
</ng-template>